import axios from 'axios';
import { LOCATION_URI, IMAGEHANDLER_URI } from '../api/apiVersionConstants';

export default {
    async getLocationData() {
        return axios.get(`${LOCATION_URI}`);
    },

    async getLocationLogo() {
        return axios.get(`${IMAGEHANDLER_URI}/getlocationlogo`);
    }
};